import { useEffect, useState } from "react";
import type { UserRole } from "@/lib/types";

export function useWelcome() {
  const [welcome, setWelcome] = useState<{ role: UserRole; name: string } | null>(null);

  useEffect(() => {
    const role = window.sessionStorage.getItem("schedora.welcomeRole") as UserRole | null;
    const name = window.sessionStorage.getItem("schedora.welcomeName");

    if (role && name) {
      setWelcome({ role, name });
      window.sessionStorage.removeItem("schedora.welcomeRole");
      window.sessionStorage.removeItem("schedora.welcomeName");
    }
  }, []);

  return welcome;
}
